module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-bold app-navbar animated",
    class: {
      slideInDown: _vm.show,
      slideOutDown: !_vm.show
    }
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('a', {
    staticClass: "nav-item is-hidden-tablet",
    on: {
      "click": function($event) {
        return _vm.toggleSidebar(!_vm.sidebar.opened)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), (!(_vm.device.isMobile || _vm.device.isTablet)) ? _c('a', {
    staticClass: "nav-item hero-brand",
    attrs: {
      "href": _vm.blog
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": _vm.logo,
      "alt": "Piscicultura Global",
      "id": "icon"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "nav-center"
  }, [(_vm.device.isMobile || _vm.device.isTablet) ? _c('router-link', {
    staticClass: "nav-item hero-brand is-hidden-desktop",
    attrs: {
      "to": "/dashboard"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": _vm.logo,
      "alt": "Piscicultura Global",
      "id": "icon"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-right"
  }, [(!(_vm.device.isMobile || _vm.device.isTablet)) ? _c('span', {
    staticClass: "nav-right nav-menu"
  }, [_c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": _vm.blog + 'blog/'
    }
  }, [_vm._v("Blog")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'Todos los cursos'
      }
    }
  }, [_vm._v("Capacitación")]), _vm._v(" "), _c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": _vm.blog + '#services'
    }
  }, [_vm._v("Servicios")]), _vm._v(" "), _c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": _vm.blog + '#about'
    }
  }, [_vm._v("Asesoría")]), _vm._v(" "), _c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": _vm.blog + '#contact'
    }
  }, [_vm._v("Contacto")])], 1) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39185e40","hasScoped":false}!./src/components/navbar/template.html
// module id = 407
// module chunks = 1